import { render, staticRenderFns } from "./Depoimentos.vue?vue&type=template&id=64337510&scoped=true&lang=pug&"
import script from "./Depoimentos.vue?vue&type=script&lang=js&"
export * from "./Depoimentos.vue?vue&type=script&lang=js&"
import style0 from "./Depoimentos.styl?vue&type=style&index=0&id=64337510&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64337510",
  null
  
)

export default component.exports